import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SnackbarProvider } from 'notistack';
import { SpectrumProvider } from '@bestdoctor/spectrum-uikit/SpectrumProvider';

import { theme } from 'ui/theme/theme';
import { SystemError } from 'ui/SystemError';

import './sentry';
import { App } from './components/App/App';

import './assets/styles/index.scss';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Хуки писали `refetchOnmount` (опечатка) — опция игнорировалась,
      // и каждый монтаж перезапрашивал данные. Дефолт закрывает это для всех запросов.
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Sentry.ErrorBoundary fallback={<SystemError />}>
    <BrowserRouter>
      <SpectrumProvider>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </QueryClientProvider>
        </SnackbarProvider>
      </SpectrumProvider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);
